import React from 'react';
import { Fab } from '@mui/material';
// import {
//   Fab,
// } from "@mui/material";
// import MyMuiFabButton from './MyMuiFabButton';

interface Props {
  disabled?: boolean;
  children?: React.ReactNode;
  onClick: () => void;
}

export default function FabButton({ 
  disabled = false,
  children,
  onClick 
}: Props) {
  // const [is_disabled, setDisabled] = useState(disabled);

  // useEffect(() => {
  //   setDisabled(disabled);
  // }, [disabled]);

  // const className =`${is_disabled ? " disabled" : ""}`;

  if (children) {
    return (
      <Fab color='primary' size="small"
        disabled={disabled} 
        onClick={onClick}>
        { children }
      </Fab>
    );
  } else {
    return (
      <Fab color='primary' size="small"
        disabled={disabled} 
        onClick={onClick}>
        <span>?</span>
      </Fab>
    );
  }
}
